var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 3.33301C10.7952 3.33301 3.3335 10.7947 3.3335 19.9997C3.3335 28.318 9.4285 35.213 17.3968 36.4647V24.8163H13.1635V19.9997H17.3968V16.328C17.3968 12.1513 19.8835 9.84467 23.6918 9.84467C25.5152 9.84467 27.4218 10.1697 27.4218 10.1697V14.2697H25.3218C23.2502 14.2697 22.6052 15.5547 22.6052 16.873V19.9997H27.2268L26.4885 24.8163H22.6052V36.4647C30.5718 35.2147 36.6668 28.3163 36.6668 19.9997C36.6668 10.7947 29.2052 3.33301 20.0002 3.33301Z",
    fill: "#0D216D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic-fb.3920b34a2127fda8f4b5bf7aceac05fc.svg";
export { ForwardRef as ReactComponent };